/**
 * Publicaciones — sección desactivada por decisión de producto.
 *
 * El panel se enfoca en moderación; programar publicaciones queda fuera
 * del scope inicial. La ruta sigue existiendo para no romper bookmarks,
 * pero muestra mensaje explicativo + link a Inbox.
 */
import { Calendar } from "lucide-react";
import { Link, useParams } from "@tanstack/react-router";
import { findClient } from "@/lib/clients";

export function PublicacionesPage() {
  const { clientSlug } = useParams({ strict: false }) as { clientSlug?: string };
  const client = findClient(clientSlug);

  return (
    <div className="min-h-full bg-background flex items-center justify-center p-7">
      <div className="card-surface max-w-md p-8 text-center border-dashed">
        <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-surface-2 mb-4 text-text-disabled">
          <Calendar size={20} strokeWidth={1.5} />
        </div>
        <h1 className="font-sans text-xl font-semibold text-text-primary mb-2">
          Publicaciones — sección no activa
        </h1>
        <p className="font-sans text-sm text-text-secondary mb-5">
          Por ahora el panel cm.champe está enfocado solo en moderación. Programar
          publicaciones queda fuera del scope inicial.
        </p>
        {client && (
          <Link
            to="/c/$clientSlug"
            params={{ clientSlug: client.slug }}
            className="inline-flex items-center justify-center h-9 px-3.5 rounded-lg bg-magenta text-white hover:bg-magenta-hover transition-colors font-sans text-sm font-medium"
          >
            Volver a {client.label}
          </Link>
        )}
      </div>
    </div>
  );
}
